<script lang="ts" setup>
import { toRefs, watch } from 'vue';
import { type GoToItem, NavigationItem, NAVIGATION_ITEMS } from '../../types';
import TocTab from '../tableOfContent/TocTab.vue';
import PagesTab from '../tableOfContent/PagesTab.vue';
import BookmarksTab from '../bookmarks/BookmarksTab.vue';
import PlaylistTab from '../tableOfContent/PlaylistTab.vue';
import HighlightsTab from '../highlights/HighlightsTab.vue';

type Emits = {
  (e: 'goToContent', item: GoToItem): void;
  (e: 'goToBookmark', item: GoToItem): void;
  (e: 'goToHighlight', item: GoToItem): void;
  (e: 'resetSearch'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  tab: number;
  search: string;
  navigationItems: NavigationItem[];
  bookId: string;
};
const props = defineProps<Props>();

const { tab, search } = toRefs(props);

watch(tab, () => {
  if (search.value) emit('resetSearch');
});

const componentMap: Record<NavigationItem, any> = {
  [NAVIGATION_ITEMS.TABLE_OF_CONTENT]: TocTab,
  [NAVIGATION_ITEMS.PAGE_LIST]: PagesTab,
  [NAVIGATION_ITEMS.BOOKMARKS_LIST]: BookmarksTab,
  [NAVIGATION_ITEMS.HIGHLIGHT_LIST]: HighlightsTab,
  [NAVIGATION_ITEMS.PLAYLIST]: PlaylistTab,
};
</script>

<template>
  <component
    :is="componentMap[navigationItems[tab]]"
    :search="search"
    :book-id="
      navigationItems[tab] === 'bookmarksList' || navigationItems[tab] === 'highlightsList' ? bookId : undefined
    "
    @go-to-content="emit('goToContent', $event)"
    @go-to-bookmark="emit('goToBookmark', $event)"
    @go-to-highlight="emit('goToHighlight', $event)"
  />
</template>
